import HTTPRequest from "./HTTPRequest";
import AppComponent from "../../../Component";

import User from "../User";
import Component from "sap/ui/core/Component";

export default class PHPBackendRequest extends HTTPRequest {
	private static readonly TOKEN = "96s5fv46ed5fve6f5b46er5tb";

	constructor(
		module: string,
		action: string,
		user: User,
		data?: Record<string, string>,
	) {
		super();
		if (!data) {
			data = {};
		}
		const component = Component.getComponentById('__component0') as AppComponent; 
		data["token"] = PHPBackendRequest.TOKEN;
		data["username"] = user.getUsername();
        data["locale"] = user.getLocale();
		this.setMethod("POST");
		this.setUrl(component.getBackendURL() + module + "/" + action);
		this.setBody(new URLSearchParams(data).toString());

		const queryParams = {
			class: module,
			action: action,
		};
		this.setQueryParams(queryParams);

		const headers = {
			"Content-Type": "application/x-www-form-urlencoded",
			"Accept": "application/json",
			"Authorization": "Bearer " + component.getUser().getToken(),
		};
		this.setHeaders(headers);

		this.setHeaders(headers);
	}
}
